// extracted by mini-css-extract-plugin
module.exports = {"container":"slider_container__cSmUf","inverted":"slider_inverted__1RoXm","bleeds":"slider_bleeds__3DEHX","aspectRatio":"slider_aspectRatio__yJYd_"};